import { Box, Grid, Link, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { links } from './AdditionalResources.constants';
import { messages } from './AdditionalResources.messages';

export const AdditionalResources = memo(() => {
    return (
        <Box color='midnight20' spacing='24' radius='small'>
            <Grid gap={16}>
                <Text font='headline' fontSize='xxsmall' fontWeight='medium' textAlign='center'>
                    {messages.title}
                </Text>

                <Grid gridTemplateColumns='repeat(auto-fit, minmax(120px, 1fr))' gap={16} justifyContent='center'>
                    {links.map(({ title, link, Icon }, index) => (
                        <Box key={index} color='white100' radius='small'>
                            <Link font='label' href={link} external color='midnight80'>
                                <Grid padding='36 16' gap={8} justifyItems='center'>
                                    <Text font='label' fontSize='small'>
                                        {title}
                                    </Text>

                                    <Icon size={24} />
                                </Grid>
                            </Link>
                        </Box>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
});

AdditionalResources.displayName = 'AdditionalResources';
